import { Award, Heart, Sparkles, Users } from "lucide-react";
import AnimatedWrapper from "./ui/AnimatedWrapper";

const infoItems = [
  { label: "Owner", value: "Putri Leony Nur R, S.E" },
  {
    label: "Lokasi",
    value: "Padasuka, Sumedang Utara | Karanglayung, Conggeang",
  },
  { label: "Area Layanan", value: "Sumedang" },
];

const features = [
  {
    icon: <Award size={26} />,
    title: "Bahan Teruji",
    description:
      "Henna pasta dan body art paint berkualitas dari brand terpercaya, diuji mandiri sebelum pemakaian",
    layout: "tall",
  },
  {
    icon: <Heart size={26} />,
    title: "Standar Kebersihan",
    description:
      "Proses aplikasi dengan standar kebersihan terjaga dan teknik profesional",
    layout: "horizontal",
  },
  {
    icon: <Sparkles size={26} />,
    title: "Design Eksklusif",
    description:
      "Setiap desain henna dirancang dan disesuaikan dengan karakteristik tangan Anda",
    layout: "compact",
  },
  {
    icon: <Users size={26} />,
    title: "Pelayanan Terbaik",
    description:
      "Konsultasi gratis dan pelayanan ramah untuk hasil yang sempurna sesuai keinginan",
    layout: "full",
  },
];

function FeatureTall({ icon, title, description, index }) {
  return (
    <AnimatedWrapper animation="scale-in" delay={index * 100}>
      <div className="relative h-full p-6 transition-all duration-500 group sm:p-8">
        {/* Gold top accent */}
        <div className="absolute top-0 left-8 right-8 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF7A]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        {/* Corner diamond */}
        <div className="absolute top-4 right-4 w-2 h-2 rotate-45 border border-[#D4AF7A]/20 group-hover:bg-[#D4AF7A]/30 group-hover:border-[#D4AF7A]/60 transition-all duration-300" />

        {/* Icon with gold diamond backdrop */}
        <div className="relative inline-flex items-center justify-center mb-6 w-14 h-14">
          <div className="absolute inset-0 rotate-45 border border-[#D4AF7A]/20 group-hover:bg-[#D4AF7A]/10 group-hover:border-[#D4AF7A]/40 transition-all duration-300" />
          <div className="absolute inset-2 rotate-45 border border-[#D4AF7A]/10 group-hover:border-[#D4AF7A]/20 transition-all duration-300" />
          <span className="relative text-[#D4AF7A] group-hover:text-[#E5C99A] transition-colors duration-300">
            {icon}
          </span>
        </div>

        <h3 className="text-lg font-bold text-[#F7F5F2] mb-3 font-display">
          {title}
        </h3>
        <p className="text-sm text-[#F7F5F2]/60 leading-relaxed">
          {description}
        </p>

        {/* Bottom hover glow */}
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#D4AF7A]/20 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-center" />
      </div>
    </AnimatedWrapper>
  );
}

function FeatureHorizontal({ icon, title, description, index }) {
  return (
    <AnimatedWrapper animation="fade-in-up" delay={index * 100}>
      <div className="relative flex items-start h-full gap-4 p-5 transition-all duration-500 group sm:p-6 sm:gap-5">
        {/* Left gold accent bar */}
        <div className="absolute left-0 top-4 bottom-4 w-[1px] bg-[#D4AF7A]/20 group-hover:bg-[#D4AF7A]/50 transition-colors duration-300" />

        {/* Icon in gold circle */}
        <div className="relative flex-shrink-0 flex items-center justify-center w-12 h-12 mt-0.5 rounded-full border border-[#D4AF7A]/20 group-hover:border-[#D4AF7A]/40 transition-all duration-300">
          <span className="text-[#D4AF7A] group-hover:text-[#E5C99A] transition-colors duration-300">
            {icon}
          </span>
          {/* Hover ring */}
          <div className="absolute inset-0 rounded-full border border-[#D4AF7A]/0 group-hover:border-[#D4AF7A]/20 scale-110 group-hover:scale-100 transition-all duration-300" />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-bold text-[#F7F5F2] mb-1.5 font-display">
            {title}
          </h3>
          <p className="text-sm text-[#F7F5F2]/60 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </AnimatedWrapper>
  );
}

function FeatureCompact({ icon, title, description, index }) {
  return (
    <AnimatedWrapper animation="scale-in" delay={index * 100}>
      <div className="relative h-full p-5 text-center transition-all duration-500 group sm:p-6">
        {/* Top-right + bottom-left corner accents */}
        <div className="absolute top-3 right-3 w-3 h-3 border-t border-r border-[#D4AF7A]/20 group-hover:border-[#D4AF7A]/50 transition-colors duration-300" />
        <div className="absolute bottom-3 left-3 w-3 h-3 border-b border-l border-[#D4AF7A]/20 group-hover:border-[#D4AF7A]/50 transition-colors duration-300" />

        {/* Icon with rotating border square */}
        <div className="relative inline-flex items-center justify-center mb-4 w-14 h-14">
          <div className="absolute inset-0 border border-[#D4AF7A]/20 group-hover:border-[#D4AF7A]/40 transition-all duration-500 group-hover:rotate-12" />
          <span className="relative text-[#D4AF7A] group-hover:text-[#E5C99A] transition-colors duration-300 group-hover:scale-110 transition-transform duration-300">
            {icon}
          </span>
        </div>

        <h3 className="text-base sm:text-lg font-bold text-[#F7F5F2] mb-2 font-display">
          {title}
        </h3>
        <p className="text-xs sm:text-sm text-[#F7F5F2]/60 leading-relaxed">
          {description}
        </p>
      </div>
    </AnimatedWrapper>
  );
}

function FeatureFull({ icon, title, description, index }) {
  return (
    <AnimatedWrapper animation="fade-in-up" delay={index * 100}>
      <div className="relative flex items-center h-full gap-4 p-5 transition-all duration-500 group sm:p-6 sm:gap-6">
        {/* Gold bottom accent */}
        <div className="absolute bottom-0 left-8 right-8 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF7A]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        {/* Full-width background shimmer on hover */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#D4AF7A]/[0.02] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-full group-hover:translate-x-full" />

        {/* Icon in rotated diamond */}
        <div className="relative flex items-center justify-center flex-shrink-0 w-12 h-12">
          <div className="absolute inset-0 rotate-45 border border-[#D4AF7A]/20 group-hover:bg-[#D4AF7A]/10 group-hover:border-[#D4AF7A]/40 transition-all duration-300" />
          <span className="relative text-[#D4AF7A] group-hover:text-[#E5C99A] transition-colors duration-300">
            {icon}
          </span>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-bold text-[#F7F5F2] mb-1 font-display">
            {title}
          </h3>
          <p className="text-sm text-[#F7F5F2]/60 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </AnimatedWrapper>
  );
}

function FeaturePanel({ feature, index }) {
  const panels = {
    tall: FeatureTall,
    horizontal: FeatureHorizontal,
    compact: FeatureCompact,
    full: FeatureFull,
  };
  const Panel = panels[feature.layout] || FeatureHorizontal;
  return <Panel {...feature} index={index} />;
}

const About = () => {
  return (
    <section
      id="about"
      className="relative py-16 overflow-hidden bg-black sm:py-20 md:py-24 lg:py-32"
    >
      {/* Atmospheric gold glow — subtle, layered */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none select-none">
        <div className="absolute top-1/4 -left-40 w-[30rem] h-[30rem] bg-[#D4AF7A]/[0.04] rounded-full blur-[120px]" />
        <div className="absolute bottom-1/3 -right-40 w-[25rem] h-[25rem] bg-[#C9A882]/[0.04] rounded-full blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50rem] h-[50rem] bg-[#D4AF7A]/[0.02] rounded-full blur-[160px]" />
      </div>

      <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* ── Section Header ── */}
        <AnimatedWrapper
          animation="fade-in-down"
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-flex items-center gap-2.5 px-4 py-1.5 border border-[#D4AF7A]/25 rounded-full text-[#D4AF7A] text-[11px] sm:text-xs font-medium tracking-[0.2em] uppercase">
            <span className="w-1 h-1 rotate-45 bg-[#D4AF7A]" />
            Tentang Kami
            <span className="w-1 h-1 rotate-45 bg-[#D4AF7A]" />
          </span>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#F7F5F2] mt-6 mb-5 font-display tracking-tight">
            Putri <span className="text-[#D4AF7A] font-display">Henna</span>{" "}
            Artist
          </h2>

          {/* Gold diamond divider */}
          <div className="flex items-center justify-center gap-3">
            <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent to-[#D4AF7A]/40" />
            <div className="relative flex items-center justify-center w-6 h-6">
              <div className="absolute w-2 h-2 rotate-45 bg-[#D4AF7A]" />
              <div className="absolute w-5 h-5 rotate-45 border border-[#D4AF7A]/20 animate-[spin-slow_10s_linear_infinite]" />
            </div>
            <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent to-[#D4AF7A]/40" />
          </div>
        </AnimatedWrapper>

        {/* ── Main Editorial Split ── */}
        <div className="grid items-stretch gap-12 mb-16 lg:grid-cols-12 lg:gap-16">
          {/* Left — Portrait with open gold frame */}
          <AnimatedWrapper
            animation="fade-in-right"
            delay={200}
            className="relative lg:col-span-5"
          >
            <div className="relative">
              {/* Gold glow behind portrait */}
              <div className="absolute -inset-6 bg-gradient-to-br from-[#D4AF7A]/15 via-transparent to-[#C9A882]/10 rounded-[3rem] blur-2xl" />

              {/* Open gold frame — only top + left lines */}
              <div className="absolute inset-0 z-10 pointer-events-none">
                {/* Top line */}
                <div className="absolute top-0 left-0 right-10 h-[1px] bg-gradient-to-r from-[#D4AF7A] via-[#E5C99A] to-transparent" />
                {/* Left line */}
                <div className="absolute top-0 left-0 bottom-10 w-[1px] bg-gradient-to-b from-[#D4AF7A] via-[#E5C99A] to-transparent" />
                {/* Top-left corner diamond */}
                <div className="absolute top-2.5 left-2.5 w-2 h-2 rotate-45 bg-[#D4AF7A]" />
              </div>

              {/* Image */}
              <div className="relative overflow-hidden">
                <img
                  src="./images/putri-leony.jpeg"
                  alt="Putri Henna Artist"
                  loading="lazy"
                  className="w-full h-auto object-cover object-center grayscale-[15%] hover:grayscale-0 transition-all duration-700"
                  style={{ minHeight: "440px" }}
                />

                <img
                  src="./logo192.png"
                  alt="Putri Henna Artist"
                  loading="lazy"
                  className="absolute top-0 right-0 object-contain object-center w-auto h-24 m-2"
                />
                {/* Subtle vignette */}
                <div className="absolute inset-x-0 bottom-0 pointer-events-none h-1/2 bg-gradient-to-t from-black/60 to-transparent" />
              </div>

              {/* Bottom-right partial frame */}
              <div className="absolute bottom-0 right-0 w-12 h-[1px] bg-gradient-to-l from-[#D4AF7A]/30 to-transparent pointer-events-none" />
              <div className="absolute bottom-0 right-0 h-12 w-[1px] bg-gradient-to-t from-[#D4AF7A]/30 to-transparent pointer-events-none" />
            </div>
          </AnimatedWrapper>

          {/* Right — Editorial Text */}
          <AnimatedWrapper
            animation="fade-in-left"
            delay={300}
            className="flex flex-col justify-center lg:col-span-7"
          >
            <div className="relative pl-6 sm:pl-8">
              {/* Vertical gold editorial rule */}
              <div className="absolute left-0 top-0 bottom-0 w-[1px] bg-gradient-to-b from-[#D4AF7A] via-[#C9A882] to-transparent" />
              <div className="absolute -left-[3px] top-0 w-[7px] h-[7px] rotate-45 bg-[#D4AF7A]" />

              {/* Script greeting */}
              <p className="font-courgette text-2xl sm:text-3xl md:text-4xl text-[#D4AF7A] mb-4 leading-none">
                Hai, Aku Putri
              </p>

              {/* Body */}
              <p className="text-sm sm:text-base md:text-lg text-[#F7F5F2]/75 leading-relaxed mb-5 max-w-prose">
                Menyediakan jasa lukis henna khusus acara pernikahan, mulai dari
                henna wedding untuk pengantin hingga henna fun untuk bridesmaid,
                pagar ayu, dan keluarga pengantin. Melayani area Sumedang.
              </p>

              {/* Gold divider */}
              <div className="w-14 h-px bg-[#D4AF7A]/30 my-6" />

              <p className="text-sm sm:text-base md:text-lg text-[#F7F5F2]/75 leading-relaxed mb-8 max-w-prose">
                Pelayanan menggunakan bahan henna yang aman untuk kulit dan
                menghasilkan warna yang indah. Selain itu, client juga bisa
                request desain henna sesuai keinginan dan kebutuhan acara.
              </p>

              {/* Info items */}
              <div className="space-y-3.5">
                {infoItems.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3 cursor-default group"
                  >
                    <div className="mt-1.5 flex-shrink-0 w-2 h-2 rotate-45 bg-[#D4AF7A]/50 group-hover:bg-[#D4AF7A] transition-colors duration-300" />
                    <div>
                      <span className="text-[#D4AF7A] text-[10px] font-semibold uppercase tracking-[0.15em]">
                        {item.label}
                      </span>
                      <p className="text-[#F7F5F2]/70 text-sm sm:text-base">
                        {item.value}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedWrapper>
        </div>

        {/* ── Section Divider ── */}
        <div className="relative flex items-center justify-center mb-14">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF7A]/15 to-transparent" />
          <div className="absolute flex items-center gap-2 px-4 bg-black">
            <span className="w-1 h-1 rotate-45 bg-[#D4AF7A]/30" />
            <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF7A]" />
            <span className="w-1 h-1 rotate-45 bg-[#D4AF7A]/30" />
          </div>
        </div>

        {/* ── Features Gapless Bento Grid ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 border border-[#D4AF7A]/10">
          {/* Feature 1 — Tall, left column spanning 2 rows */}
          <div className="border-b md:border-b-0 border-[#D4AF7A]/10 md:border-r md:row-span-2">
            <FeatureTall {...features[0]} index={0} />
          </div>

          {/* Feature 2 — Horizontal, top right */}
          <div className="md:col-span-2 border-b border-[#D4AF7A]/10">
            <FeatureHorizontal {...features[1]} index={1} />
          </div>

          {/* Feature 3 — Compact, bottom left of right area */}
          <div className="border-b md:border-b-0 border-[#D4AF7A]/10 md:border-r">
            <FeatureCompact {...features[2]} index={2} />
          </div>

          {/* Feature 4 — Full, bottom right */}
          <div className="md:col-span-1">
            <FeatureFull {...features[3]} index={3} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
